import get from 'lodash/get';

// Which of the conversation's stored suggestions to show the agent.

// Suggestions from generative-ai stay stored for earlier messages and other agents.
const GENERATIVE_AI = 'generative-ai';

// The customer's latest text message in the chat, from any of their conversations. As in base-api, only
// messages with content that aren't events count.
export const latestCustomerMessageId = (messages) => {
  const ids = (messages || [])
    .filter(message => message.sender_type === 'customers' && get(message, 'payload.content') && !message.event)
    .map(message => message.id);
  return ids.length ? Math.max(...ids) : null;
};

// A document marked public; a private or unmarked one is internal.
export const isPublicDocument = suggestion => get(suggestion, 'metadata.type') === 'document'
  && get(suggestion, 'metadata.private') === false;

// The link sent with a document's answer: only a public document has one.
export const publicDocumentUrl = suggestion => (isPublicDocument(suggestion) && get(suggestion, 'metadata.url')) || null;

export const hasGenerativeAiSuggestions = suggestions => (suggestions || [])
  .some(suggestion => get(suggestion, 'metadata.source') === GENERATIVE_AI);

/**
 * The suggestions to show: from generative-ai only those for the customer's latest message, made for this
 * agent; other suggestions, e.g. IQ Tools responses, as they are.
 *
 * @param suggestions the conversation's suggestions
 * @param latestMessageId id of the customer's latest text message
 * @param agentId the agent viewing the conversation
 */
export const currentSuggestions = (suggestions, latestMessageId, agentId) => (suggestions || [])
  .filter(suggestion => get(suggestion, 'metadata.source') !== GENERATIVE_AI || (
    get(suggestion, 'metadata.response_to') === latestMessageId
    && Number(get(suggestion, 'metadata.agent_id')) === Number(agentId)));
